import { useMemo } from 'react';
import { CurrencyIcon } from '~/components/collections';
import {
	NumberplatePreview,
	NumberPlatePreviewSize,
} from '~/components/ui/NumberplatePreview';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { rage } from '~/rage';
import { Currency, VehicleNumberPlate } from '~/shared';
import { useLayoutSelector } from '../../redux';
import { CarMarketState } from '../../views/CarMarket/CarMarket.model';
import { CarPreviewDecor } from '../CarPreviewDecor';
import {
	StyledBottomContainer,
	StyledContainer,
	StyledImage,
	StyledName,
	StyledPriceContainer,
	StyledUpInfoContainer,
} from './CarPreview.styled';

const CarPreview = ({
	price,
	vehicleId,
	numberPlate,
}: {
	price?: number;
	vehicleId?: string;
	numberPlate?: VehicleNumberPlate;
}) => {
	const carMarketState = useLayoutSelector(
		(state) => state.carMarket.carMarketState,
	);

	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	const vehicleName = useMemo(
		() => (vehicleId ? rage.vehicles.getVehicleNameByModel(vehicleId) : ''),
		[vehicleId],
	);

	const priceLabel = useMemo(() => {
		if (carMarketState === CarMarketState.Edit) return 'Текущая стоимость';
		if (carMarketState === CarMarketState.Create) return 'Гос. стоимость';
		return 'Стоимость';
	}, [carMarketState]);

	return (
		<StyledContainer>
			<CarPreviewDecor withPriceBar={!!price} />
			<StyledUpInfoContainer>
				<StyledName>{vehicleName}</StyledName>
				<NumberplatePreview
					numberPlate={numberPlate}
					size={NumberPlatePreviewSize.Size20}
				/>
			</StyledUpInfoContainer>
			<StyledImage collection={'vehicles'} size={'md'} id={vehicleId || ''} />
			{price ? (
				<StyledBottomContainer>
					<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.5 }}>
						{priceLabel}
					</Text>
					<StyledPriceContainer>
						<Text>{price?.toLocaleString('ru-RU')}</Text>
						<CurrencyIcon icon={rubleIcon} size="md" />
					</StyledPriceContainer>
				</StyledBottomContainer>
			) : null}
		</StyledContainer>
	);
};

export { CarPreview };
